import { jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSLayout } from '../../layout/layout/index.esm.js';
import 'react';
import { EGDSLayoutSpaces, EGDSLayoutSizes } from '../../layout/types/index.esm.js';
import styles from '../../styles/uitk-egds-layout-columns.css';
import { EGDSLayoutColumnCounts } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSLayoutColumns = props => {
  const {
    children,
    className,
    space,
    tag,
    columns,
    minWidth,
    ...attributes
  } = props;
  const baseClass = 'uitk-layout-columns';
  const wrapperClassNames = getClassNameList(baseClass, columns && `${baseClass}-${EGDSLayoutColumnCounts.get(columns)}`, space && `${baseClass}-${EGDSLayoutSpaces.get(space)}`, minWidth && `${baseClass}-minwidth-${EGDSLayoutSizes.get(minWidth)}`, className);
  return jsx(EGDSLayout, {
    className: wrapperClassNames,
    tag: tag,
    ...attributes,
    children: children || null
  });
};
export { EGDSLayoutColumns };